module.exports = __webpack_public_path__ + "img/3-4.fe5b3732.png";